import { isNewOttFeatureEnabled } from '@/constants/env';

import { classicOttSources, newOttSourceQueryKey } from './constants.js';

/**
 * New OTT gate when the feature flag is on and `source` is not a classic flow value.
 * `password_reset_link`, `user_provisioning`, and `password_reset_email` stay on set password.
 */
export const isNewOttGateFlow = (
  searchParams: URLSearchParams,
  isFeatureEnabled: boolean = isNewOttFeatureEnabled
): boolean => {
  const source = searchParams.get(newOttSourceQueryKey);

  return Boolean(isFeatureEnabled) && !classicOttSources.includes(source ?? '');
};
